import { api, unwrap } from './api';
export const authService = {
    login(email, password) {
        return unwrap(api.post('/cms/auth/login', { email, password }));
    },
    me() {
        return unwrap(api.get('/cms/auth/me'));
    },
    updateProfile(fullName) {
        return unwrap(api.patch('/cms/auth/me', { fullName }));
    },
    changePassword(currentPassword, newPassword) {
        return unwrap(api.patch('/cms/auth/me/password', { currentPassword, newPassword }));
    },
};
